/**
 * Calculates the total net amount for a given base (net or gross) amount.
 *
 * @param amount The base amount:
 * 	- if isTaxIncluded = false, this is the net amount (before tax)
 * 	- if isTaxIncluded = true,  this is the gross amount (including tax)
 * @param taxRate The tax rate as a percentage (e.g. 19 for 19%).
 * @param isTaxIncluded Whether `amount` already includes tax (gross). Defaults to false.
 * @returns The net amount.
 * @example
 * ```ts
 * const amount = 400;
 * const taxRate = 19;
 * const isTaxIncluded = true;
 * const totalNet = amountToTotalNet(amount, taxRate, isTaxIncluded);
 * console.log(totalNet); // Output: 336.1344537815126
 * ```
 * @example
 * ```ts
 * const amount = 400;
 * const taxRate = 19;
 * const isTaxIncluded = false;
 * const totalNet = amountToTotalNet(amount, taxRate, isTaxIncluded);
 * console.log(totalNet); // Output: 400
 * ```
 */
export function amountToTotalNet(
	amount?: number | null,
	taxRate?: number | null,
	isTaxIncluded?: boolean | null,
): number {
	// Sanitize
	const base = amount == null || isNaN(amount) ? 0 : amount;
	const rate = taxRate == null || isNaN(taxRate) ? 0 : taxRate;

	// If amount already includes tax, just return it, otherwise remove tax from the base amount
	return isTaxIncluded ? base / (1 + rate / 100) : base;
}
